import React, { useEffect } from 'react';
import { ErrorPage } from '@src/shared/ui';
import { useErrorState, useGTM, useProposalState } from '@src/shared/hooks';
import { GTMEvents } from '@src/config/gtm';

export const SessionPage: React.FC = () => {
  const { trackEvent } = useGTM();
  const { proposal } = useProposalState();
  const { etapa } = useErrorState();

  useEffect(() => {
    trackEvent(GTMEvents.SESSION_EXPIRED, {
      etapa,
      proposal_id: proposal.proposalId,
    });
  }, []);

  return (
    <ErrorPage
      title='Ops, sua sessão expirou'
      description="Por favor, refaça seu pedido no site da GOL Linhas Aéreas e selecione o 'Boleto Parcelado PaGol' como forma de pagamento. Estamos aguardando!"
      backToGolButtonPrimary
    />
  );
};
